import CombatManager from '../CombatManager';
import { rollDie } from '../../../../shared/rules/engine';

/** Detached seed/cursor ledger, committed only with successful actions.
 * Manual faces remain explicit player/GM input. date_of_change: 2026-09-05
 */
export async function collectCreatureFaces(actor, state, sides, count, requestManual) {
  const manual = CombatManager.shouldUseManualRolls(actor);
  const faces = manual ? await requestManual() : Array.from({ length: count }, () => rollDie(state, sides));
  if (!Array.isArray(faces) || faces.length === 0) throw Object.assign(new Error('Roll cancelled; no combat state was committed.'), { code: 'ACTION_CANCELLED', cancelled: true });
  if (faces.length !== count || faces.some(face => typeof face !== 'number' || !Number.isInteger(face) || face < 1 || face > sides)) throw new Error(`${actor.id}: expected ${count} raw d${sides} faces.`);
  if (state.creatureResolution) state.creatureRolls.push(...faces.map(face => ({ actorId: actor.id, sides, face, mode: manual ? 'manual' : 'digital' })));
  return faces;
}
